import { Injectable, Logger } from '@nestjs/common';
import { Cron } from '@nestjs/schedule';
import { PedidosService } from './pedidos.service';

@Injectable()
export class OrdenesVentaCron {
  private readonly logger = new Logger(OrdenesVentaCron.name);

  constructor(private readonly service: PedidosService) {}

  /** Diariamente a las 06:00: marcar órdenes de venta vencidas y liberar stock */
  @Cron('0 6 * * *')
  async vencerOrdenes() {
    try {
      const count = await this.service.vencerOrdenesExpiradas();
      if (count > 0) this.logger.log(`Vencidas: ${count} órdenes de venta`, 'OrdenesVentaCron');
    } catch (err) {
      this.logger.error('Error en job vencerOrdenes', err);
    }
  }
}
